import { useCallback, useMemo } from 'react';
import {
  Edit,
  FunctionField,
  Labeled,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  UpdateButton,
  required,
  useGetIdentity,
} from 'react-admin';

import { MarkdownField } from '@/components/MarkdownField';
import { Box, Chip } from '@mui/material';
import { Delete } from '@mui/icons-material';

export const AppGlobalAlertsEdit = () => {
  const userId = useGetIdentity().data?.id?.toString();

  const transform = useCallback(
    (data: any) => {
      console.log('data', data);

      return {
        ...data,
        updatedBy: userId,
        updatedAt: new Date(),
      };
    },
    [userId],
  );

  return (
    <Edit
      mutationMode="pessimistic"
      actions={false}
      transform={transform}
    >
      <SimpleForm toolbar={<EditToolbar />}>
        <FunctionField
          label="Id"
          render={(rec: any) => {
            const idStr =
              typeof rec?.id === 'string'
                ? rec.id
                : typeof rec?.id?.toHexString === 'function'
                  ? rec.id.toHexString()
                  : String(rec?.id ?? '');
            return (
              <Labeled label="Id">
                <Chip label={idStr} />
              </Labeled>
            );
          }}
        />
        <TextInput
          label="Title"
          source="title"
          validate={[required()]}
          fullWidth
        />
        <TextInput
          label="Single Line Description"
          source="singleLineDescription"
          validate={[required()]}
          fullWidth
        />
        <MarkdownField label="Alert Content" source="content" />
      </SimpleForm>
    </Edit>
  );
};

export const EditToolbar = () => {
  const userId = useGetIdentity().data?.id?.toString();

  const archiveData = useMemo(
    () => ({
      archivedAt: new Date(),
      archivedBy: userId,
    }),
    [userId],
  );

  return (
    <Toolbar>
      <Box
        width="100%"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
      >
        <SaveButton label="Save" />
        <UpdateButton
          label="Archive"
          icon={<Delete />}
          data={archiveData}
        />
      </Box>
    </Toolbar>
  );
};
